module.exports = __webpack_public_path__ + "static/img/sign-click.c8fb891.png";


//////////////////
// WEBPACK FOOTER
// ./static/sign-click.png
// module id = ygwD
// module chunks = 0